import type { ConsentPurpose } from './contract'

export const CONSENT_CONFIG_VERSION = 'cp-cookie-v1'
export const CONSENT_DEVICE_COOKIE = 'le_consent_device'
export const CONSENT_PENDING_COOKIE = 'le_consent_pending'

export interface ConsentEvidence {
  notice_version: string
  vendor_version: string
  config_version: string
}
export interface ConsentReceipt extends ConsentEvidence {
  revision: string
}
export interface BackendConsent {
  purpose_key: ConsentPurpose
  purpose_version: string
  granted: boolean
  last_action: string | null
  decided_at: string | null
  valid_until: string | null
}
export interface BackendConsentState {
  subject_id: string
  revision: string
  consents: Array<BackendConsent>
}
export interface ConsentContext {
  purposes: Array<{ key: ConsentPurpose; version: string }>
  state?: BackendConsentState
}
export interface ConsentDecision {
  subject_id: string
  idempotency_key: string
  revision: string
  method: 'ACCEPT_ALL' | 'NECESSARY_ONLY' | 'CONFIGURE'
  notice_version: string
  vendor_version: string
  config_version: string
  language_version: string
  consents: Array<{ purpose_key: ConsentPurpose; purpose_version: string; granted: boolean }>
}
export interface ConsentDecisionResult extends BackendConsentState {
  replayed: boolean
  expires_at: string
}

export function hasCurrentConsentEvidence(receipt: ConsentEvidence | undefined, evidence: ConsentEvidence): boolean {
  return (
    receipt?.notice_version === evidence.notice_version &&
    receipt.vendor_version === evidence.vendor_version &&
    receipt.config_version === evidence.config_version
  )
}
